/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from "react";
import ContentLoader from "react-content-loader";
import {SkeletonSettings} from "../../../../../../atoms/effects/skeletons/utils/SkeletonSettings";

export const ConfirmationSkeleton = (props) => (
    <ContentLoader
        height={"100vh"}
        width={"100%"}
        speed={SkeletonSettings.SPEED}
        backgroundColor={SkeletonSettings.BACKGROUND}
        foregroundColor={SkeletonSettings.FOREGROUND}
        {...props}>

        {/* First row */}
        <rect x="0" y="12" rx="3" ry="3" width="100%" height="230"/>

        {/* Second row */}
        <rect x="0" y="267" rx="3" ry="3" width="100%" height="400"/>

        {/* Third row - left */}
        <rect x="0" y="692" rx="3" ry="3" width="75%" height="300"/>

        {/* Third row - right */}
        <rect x={`calc(75% + 20px)`} y="692" rx="3" ry="3" width={`calc(25% - 20px)`} height="250"/>

    </ContentLoader>
)
